<template>
  <div
    class="my-car-visits"
    :class="{
      'padding-bottom': showSwitch,
    }"
  >
    <transition-group name="fade">
      <template v-if="!$route.path.includes('history') && nextVisits.length">
        <p key="1">
          Lista Twoich zbliżających się wizyt
        </p>
        <div
          class="my-car-visits-wrapper"
          key="2"
        >
          <visit-block
            :visit="visit"
            v-for="(visit, index) in nextVisits"
            :car="singleCarMode ? specificCar : getCarByID(visit.carID)"
            :type="visit.dateMode"
            :key="'next' + index"
          />
        </div>
      </template>
      <p
        v-if="pageType === 'next' && !nextVisits.length"
        key="3"
      >
        Brak zbliżających się wizyt do wyświetlenia
      </p>
      <p
        v-if="pageType === 'history' && !historyVisits.length"
        key="4"
      >
        Brak poprzednich wizyt do wyświetlenia
      </p>
      <template v-if="(mode === 'history' || $route.path.includes('history')) && historyVisits.length">
        <p key="6">
          List Twoich poprzednich wizyt
        </p>
        <div
          class="my-car-visits-wrapper"
          key="7"
        >
          <visit-block
            :visit="visit"
            v-for="(visit, index) in historyVisits"
            :car="singleCarMode ? specificCar : getCarByID(visit.carID)"
            :type="visit.dateMode"
            :key="'history' + index"
          />
        </div>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VisitBlock from '~/VisitBlock';
import dayjs from 'dayjs';

export default {
  props: {
    pageType: {
      default: () => '',
      type: String,
    },
    showSwitch: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    VisitBlock,
  },
  computed: {
    ...mapGetters({
      userCars: 'myCars/getMyCars',
      showHistoryVisits: 'visit/showHistoryVisits',
    }),
    mode() {
      if (!this.showHistoryVisits) {
        return 'next';
      }
      return 'history';
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    singleCarMode() {
      if (this.$route.params.id !== 'all') {
        return true;
      }
      return false;
    },
    specificCar() {
      // eslint-disable-next-line
      return this.userCars.find(car => car.id == this.$route.params.id);
    },
    allVisits() {
      const allVisits = [];
      let { userCars } = this;

      if (this.singleCarMode) {
        // eslint-disable-next-line
        userCars = userCars.filter(car => car.id == this.$route.params.id);
      }

      userCars.forEach((car) => {
        const visits = car.visits.map((visit) => {
          const date = dayjs(visit.date);
          const today = dayjs();

          if (visit.status === 'Sfinalizowana' || date.isBefore(today)) {
            return {
              ...visit,
              dateMode: 'history',
              carID: car.id,
            };
          }
          return {
            ...visit,
            dateMode: 'next',
            carID: car.id,
          };
        });

        allVisits.push(...visits);
      });

      return allVisits
        .sort((prev, next) => dayjs(prev.date).valueOf() - dayjs(next.date).valueOf());
    },
    historyVisits() {
      return this.allVisits.filter(visit => visit.dateMode === 'history');
    },
    nextVisits() {
      return this.allVisits.filter(visit => visit.dateMode === 'next');
    },
  },
  methods: {
    getCarByID(id) {
      return this.userCars.find(car => car.id === id);
    },
  },
};
</script>
